// API configuration for connecting to the worker
// In development, this uses the Vite proxy
// In production, this points to the deployed worker

const API_BASE = import.meta.env.VITE_API_URL || '';

export function getApiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export function getWsUrl(path: string): string {
  if (API_BASE) {
    // Production: use the worker URL
    const url = new URL(API_BASE);
    const wsProtocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${url.host}${path}`;
  }
  // Development: use same host (proxied by Vite)
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path}`;
}
